import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type OrderConfirmation } from "./types";

export default {
  init: (
    apiInfo: ModuleApiInfo,
    args: OrderConfirmation.Api.InitRequest
  ): Promise<HttpApiResponse<OrderConfirmation.Api.InitResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/orderConfirmation`, args),
  downloadInvoice: (apiInfo: ModuleApiInfo, args: OrderConfirmation.Api.DownloadInvoiceRequest): Promise<void> =>
    api.download(apiInfo, `/api/site/v1/modules/orderConfirmation/invoice`, args),
  createComment: (
    apiInfo: ModuleApiInfo,
    id: string,
    comment: string
  ): Promise<HttpApiResponse<OrderConfirmation.Api.CreateCommentResponse>> =>
    api.post(apiInfo, `/api/site/v1/modules/orderConfirmation/${id}/comment`, { comment })
};
